import React from 'react';
import styles from './AudioTabContent.module.scss';
import { Slider, T } from '@colonist/ui';
export const AudioTabContent = ({ volume, isMuted, onVolumeChanged })=>{
    const displayVolume = isMuted ? 0 : volume;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.audioTabContentContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:game.settings.audioTab.volume"
    })), /*#__PURE__*/ React.createElement(Slider, {
        onChange: onVolumeChanged,
        value: displayVolume,
        min: 0,
        max: 100
    }));
};
